export default __webpack_public_path__ + "static/media/round_winner.bb37bb30.mp3";